__turbopack_context__.v({
  "fullscreenOverlay": "Portal-module-scss-module__FKUZNG__fullscreenOverlay",
  "modalWindow": "Portal-module-scss-module__FKUZNG__modalWindow",
  "modalWindowBackdrop": "Portal-module-scss-module__FKUZNG__modalWindowBackdrop",
  "popup": "Portal-module-scss-module__FKUZNG__popup",
  "popup-backdrop-fadein": "Portal-module-scss-module__FKUZNG__popup-backdrop-fadein",
  "popupBackdrop": "Portal-module-scss-module__FKUZNG__popupBackdrop",
});
